/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-2",
    "aws_cognito_identity_pool_id": "eu-west-2:aec40e12-befb-4a42-ab65-286293b9e626",
    "aws_cognito_region": "eu-west-2",
    "aws_user_pools_id": "eu-west-2_qtu37O2qn",
    "aws_user_pools_web_client_id": "301e27c6f1824ifs507a92cgka",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "FAMILY_NAME"
    ],
    "aws_cognito_mfa_configuration": "OPTIONAL",
    "aws_cognito_mfa_types": [
        "TOTP"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_appsync_graphqlEndpoint": "https://6ivygrvenjeblnmwfotkwjq3ua.appsync-api.eu-west-2.amazonaws.com/graphql",
    "aws_appsync_region": "eu-west-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cloud_logic_custom": [
        {
            "name": "webhooks",
            "endpoint": "https://i2aeblvtz5.execute-api.eu-west-2.amazonaws.com/prod",
            "region": "eu-west-2"
        }
    ],
    "aws_user_files_s3_bucket": "clem-viewing-reports153721-prod",
    "aws_user_files_s3_bucket_region": "eu-west-2"
};


export default awsmobile;
